import React from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { Cell } from 'fixed-data-table-2'
import classnames from 'classnames/bind'
import DataTableUtils from '../utils'
import styles from '../styles.scss'
import {
  convertDateFormat,
  formatDateApiToUi,
  formatDateApiToUiFromPattern,
  formatDateFromPattern,
  formatDateTimeApiToUi,
  API_DATE_FORMAT,
} from '../../../utils/date'
const cx = classnames.bind(styles)

export const renderValue = (
  value,
  { dateFormat, displayFormat, midnightAllowed, pattern = API_DATE_FORMAT }
) => {
  switch (dateFormat) {
    case 'date':
      return formatDateApiToUi(value, displayFormat)
    case 'dateAgnostic':
      return convertDateFormat(value, pattern, displayFormat)
    case 'datePattern':
      return formatDateFromPattern(value, pattern, displayFormat)
    case 'datePatternPST':
      return formatDateApiToUiFromPattern(value, pattern)
    default:
      return formatDateTimeApiToUi(value, midnightAllowed)
  }
}

const DateCell = props => {
  const { rowIndex, definition, data, ...restProps } = props
  const { field } = definition
  const baseField = field.substring(field.lastIndexOf('.') + 1)
  const row = data[rowIndex]

  return (
    <Cell
      data-elm-id={`${baseField}_${rowIndex}_cell`}
      className={cx('cell')}
      {...restProps}
    >
      <div
        data-elm-id={`${baseField}_${rowIndex}_value`}
        style={{ width: DataTableUtils.getCellInnerWidth(definition.colProps) }}
        className={cx('text-truncate')}
      >
        {renderValue(
          _.get(row, field) || row[baseField],
          definition.formatOptions || {}
        )}
      </div>
    </Cell>
  )
}

/**
 * formatOptions for DateCell allow for different date format functions with optional arguments.
 * e.g. formatOptions: {
 *  dateFormat: 'date',
 *  displayFormat: 'MM/DD/YYYY',
 *  pattern: 'YYYY-MM-DDTHH:mm:ss[Z]'
 * }
 */

DateCell.propTypes = {
  rowIndex: PropTypes.number,
  definition: PropTypes.shape({
    colProps: PropTypes.object.isRequired,
    field: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    formatOptions: PropTypes.shape({
      dateFormat: PropTypes.string,
      displayFormat: PropTypes.string,
      pattern: PropTypes.string,
    }),
  }).isRequired,
  data: PropTypes.array,
}

export default DateCell
